import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { withRouter } from "react-router-dom";
import queryString from "query-string";
import Vimeo from "react-vimeo-embed";
import InProgress from "assets/img/inprogress.jpeg";
import appstore from "assets/img/appstore.png";
import googleplay from "assets/img/googleplay.png";
import welcomeThumbnail from "assets/img/1Thumbnail.jpg";
import onboardingThumbnail from "assets/img/2Thumbnail.jpg";
import inventoryAiThumbnail from "assets/img/3Thumbnail.jpg";
import * as LotActionType from "Lots/constants";
import "./intro.scss";

const cards = [
  {
    icon: "fa fa-file-text-o",
    title: "Documents",
    desc: "Effortlessly organize all your home documents.",
    link: "/documents",
  },
  {
    icon: "fa fa-shopping-cart",
    title: "Inventory",
    desc: "Organize and manage all your home assets in one place.",
    link: "/inventory",
  },
  {
    icon: "fa fa-wrench",
    title: "Maintenance",
    desc: "Receive automated maintenance notices.",
    link: "/home-maintenance",
  },
  {
    icon: "fa fa-lightbulb-o",
    title: "Home Care",
    desc: "Stay on top of cleaning, seasonal upkeep, and home care tasks.",
    link: "/home-care",
  },
  // {
  //   icon: "fa fa-star",
  //   title: "Smart Home",
  //   desc: "Centralized management for all your home apps.",
  //   link: "",
  // },
  // {
  //   icon: "fa fa-plus-circle",
  //   title: "Add Items",
  //   desc: "Add categories, docs, inventory, and apps easily.",
  //   link: "",
  // },
  // {
  //   icon: "fa fa-database",
  //   title: "Finance",
  //   desc: "Coming soon with HomeHub: Home expense reports.",
  //   link: "",
  // },
];

const S3_VIDEO_BASE_URL =
  "https://siteoneservices.s3.dualstack.us-west-2.amazonaws.com/HomeHub360SharedFiles";

const gettingStartedVideos = [
  {
    title: "Welcome to HomeHub360",
    image: welcomeThumbnail,
    link: `${S3_VIDEO_BASE_URL}/Welcome_Video.mp4`,
  },
  {
    title: "Adding Inventory With AI",
    image: inventoryAiThumbnail,
    link: `${S3_VIDEO_BASE_URL}/Adding_Inventory_With_AI.mp4`,
  },
  {
    title: "Your Home Readiness.",
    image: onboardingThumbnail,
    link: `${S3_VIDEO_BASE_URL}/OnBoarding_Video.mp4`,
  },
];

const videoDetails = [
  // {
  //   title: "Welcome home!",
  //   time: "Video - 1:20",
  //   image: InProgress,
  //   link: "https://vimeo.com/583039702",
  // },
  {
    title: "How to use your water meter to find leaks",
    time: "Video - 0:50",
    image: InProgress,
    link: "https://vimeo.com/1095094827",
  },
  {
    title: "How to apply caulk",
    time: "Video - 3:44",
    image: InProgress,
    link: "https://vimeo.com/1095092637",
  },
  {
    title: "How to shutoff the gas in case of emergency",
    time: "Video - 1:04",
    image: InProgress,
    link: "https://vimeo.com/584030969",
  },
  {
    title: "How to reset an application at your breaker subpanel",
    time: "Video - 2:33",
    image: InProgress,
    link: "https://vimeo.com/583041020",
  },
  {
    title: "How to clear your in sink disposal",
    time: "Video - 2:17",
    image: InProgress,
    link: "https://vimeo.com/583040642",
  },
  {
    title: "How to shut off the water to your home at the main valve",
    time: "Video - 1:23",
    image: InProgress,
    link: "https://vimeo.com/583040348",
  },
  {
    title: "How to change the battery in your smoke detectors",
    time: "Video - 2:21",
    image: InProgress,
    link: "https://vimeo.com/583040052",
  },
  {
    title: "How to reset an electrical outlet GFCI",
    time: "Video - 2:33",
    image: InProgress,
    link: "https://vimeo.com/583041390",
  },
  // {
  //   title: "How to Review work orders in just 3 clicks!",
  //   time: "Video - 2:47",
  //   image: InProgress,
  //   link: "https://vimeo.com/936800882",
  // },
  // {
  //   title: "Home inventory overview",
  //   time: "Video - 0:39",
  //   image: InProgress,
  //   link: "https://vimeo.com/583138003",
  // },
  // {
  //   title: "Introtroduction to siteone's digital publications",
  //   time: "Video - 4:03",
  //   image: InProgress,
  //   link: "https://vimeo.com/583125026",
  // },
  // {
  //   title: "Home orientation with electronic forms and homehub",
  //   time: "Video - 3:40",
  //   image: InProgress,
  //   link: "https://vimeo.com/583123994",
  // },
];

// Click-to-play card for self-hosted (S3) mp4 videos.
// Nothing is downloaded until the user hits play - the poster carries the card.
class IntroVideoCard extends Component {
  static propTypes = {
    video: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      isPlaying: false,
    };
  }

  handlePlay = () => {
    this.setState({ isPlaying: true });
  };

  render() {
    const { video } = this.props;
    const { isPlaying } = this.state;

    return (
      <div className="intro-video-card">
        <div className="intro-video-frame">
          {isPlaying ? (
            <video
              className="intro-video-player"
              src={video.link}
              poster={video.image}
              controls
              autoPlay
              playsInline
            />
          ) : (
            <button
              type="button"
              className="intro-video-poster"
              style={{ backgroundImage: `url(${video.image})` }}
              onClick={this.handlePlay}
              aria-label={`Play video: ${video.title}`}
            >
              <span className="intro-video-play">
                <svg viewBox="0 0 100 100" focusable="false" aria-hidden="true">
                  <circle cx="50" cy="50" r="50" />
                  <polygon points="40,28 74,50 40,72" />
                </svg>
              </span>
            </button>
          )}
        </div>
        <div className="intro-video-title">{video.title}</div>
      </div>
    );
  }
}

// Lazy Loading Video Component
class LazyVideo extends Component {
  static propTypes = {
    video: PropTypes.object.isRequired,
    index: PropTypes.number.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      isVisible: false,
      isLoading: false,
      isLoaded: false,
    };
    this.videoRef = React.createRef();
    this.observer = null;
  }

  componentDidMount() {
    // Create Intersection Observer
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !this.state.isVisible && !this.state.isLoaded) {
            this.setState({ 
              isVisible: true, 
              isLoading: true 
            });
            // Stop observing once video starts loading
            this.observer.unobserve(entry.target);
          }
        });
      },
      {
        root: null,
        rootMargin: '50px', // Load video 50px before it enters viewport
        threshold: 0.1, // Trigger when 10% of the element is visible
      }
    );

    if (this.videoRef.current) {
      this.observer.observe(this.videoRef.current);
    }
  }

  componentWillUnmount() {
    if (this.observer && this.videoRef.current) {
      this.observer.unobserve(this.videoRef.current);
    }
  }

  handleVideoLoad = () => {
    this.setState({ 
      isLoading: false, 
      isLoaded: true 
    });
  };

  render() {
    const { video, index } = this.props;
    const { isVisible, isLoading, isLoaded } = this.state;

    return (
      <div className="video-item" key={index} ref={this.videoRef}>
        {isVisible && !isLoaded && (
          // Show loader while video is loading
          <div
            style={{
              width: "100%",
              height: "200px",
              backgroundColor: "#f8f9fa",
              borderRadius: "12px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              position: "relative",
              border: "1px solid #e9ecef",
            }}
          >
            {/* Animated Loader */}
            <div
              style={{
                width: "40px",
                height: "40px",
                border: "4px solid #e3e3e3",
                borderTop: "4px solid #4267AE",
                borderRadius: "50%",
                animation: "spin 1s linear infinite",
                marginBottom: "15px",
              }}
            />
            <div
              style={{
                fontSize: "14px",
                color: "#6c757d",
                fontWeight: "500",
                marginBottom: "5px",
              }}
            >
              Loading video...
            </div>
            <div
              style={{
                fontSize: "12px",
                color: "#6c757d",
                textAlign: "center",
                padding: "0 20px",
              }}
            >
              {video.title}
            </div>
            
            {/* CSS Animation for spinner */}
            <style>
              {`
                @keyframes spin {
                  0% { transform: rotate(0deg); }
                  100% { transform: rotate(360deg); }
                }
              `}
            </style>
          </div>
        )}
        
        {isVisible && (
          <div style={{ display: isLoaded ? 'block' : 'none' }}>
            <Vimeo
              video={video.link}
              responsive={true}
              onReady={this.handleVideoLoad}
              onError={this.handleVideoLoad} // Handle error case as well
              style={{
                width: "100%",
                height: "100%",
                borderRadius: "12px",
              }}
            />
          </div>
        )}
        
        {!isVisible && (
          // Placeholder while video is not visible
          <div
            style={{
              width: "100%",
              height: "200px",
              backgroundColor: "#f0f0f0",
              borderRadius: "12px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              backgroundImage: `url(${video.image})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              position: "relative",
              cursor: "pointer",
            }}
          >
            {/* Preview overlay */}
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                borderRadius: "12px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                color: "white",
              }}
            >
              <div
                style={{
                  fontSize: "48px",
                  marginBottom: "10px",
                  opacity: 0.9,
                }}
              >
                ▶
              </div>
              <div
                style={{
                  fontSize: "14px",
                  fontWeight: "bold",
                  textAlign: "center",
                  padding: "0 10px",
                  marginBottom: "5px",
                }}
              >
                {video.title}
              </div>
              <div
                style={{
                  fontSize: "12px",
                  opacity: 0.8,
                }}
              >
                {video.time}
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

class HomeownerIntro extends Component {
  static propTypes = {
    dispatch: PropTypes.func,
    homeownerLots: PropTypes.array,
    homeownerDocumentTypes: PropTypes.array,
    location: PropTypes.any,
    history: PropTypes.any,
  };

  constructor(props) {
    super(props);

    this.queryParams = queryString.parse(location.search);
    this.lotId = this.queryParams.lotId;

    this.state = {
      rfsUrl: "/",
    };
  }

  componentDidMount() {
    this.getHomeownerLotList();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.homeownerLots.length > 1) {
      this.setState({ rfsUrl: '/lots' });
    }
    else if (nextProps.homeownerLots.length > 0) {
      this.setState({ rfsUrl: '/lot/' + nextProps.homeownerLots[0].lot.id + '/request/add' });
    }
  }

  getHomeownerLotList = () => {
    this.props.dispatch({
      type: LotActionType.GET_HOMEOWNER_LOT_LIST_ASYNC
    });
  };

  render() {
    return (
      <div
        className="container-fluid"
        style={{
          fontFamily:
            "'Inter', 'Segoe UI', 'Helvetica Neue', 'Arial', sans-serif !important",
          backgroundColor: "white",
          marginLeft: "10px",
        }}
      >
        <p
          style={{ color: "#878787", marginTop: "20px", marginBottom: "40px" }}
        >
          Welcome to HomeHub, your all-in-one solution for home management.
          Effortlessly organize and manage all your home assets.
        </p>
        <h3
          style={{
            fontWeight: "bold",
            color: "#323232",
            fontFamily: "sans-serif",
          }}
        >
          Essentials
        </h3>
        <div
          className="row"
          style={{
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            marginLeft: "5px",
            marginTop: "20px",
          }}
        >
          {cards.map((item, index) => (
            <Link to={item.link} key={index} style={{ textDecoration: "none" }}>
              <div
                className="well"
                style={{
                  backgroundColor: "#EDF4FF",
                  border: "none",
                  borderRadius: "8px",
                  padding: "15px",
                  marginRight: "20px",
                  height: "102px",
                  width: "255px",
                  display: "flex",
                  flexDirection: "column",
                  cursor: "pointer",
                  transition: "transform 0.2s, box-shadow 0.2s",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-2px)";
                  e.currentTarget.style.boxShadow = "0 4px 12px rgba(66, 103, 174, 0.15)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow = "none";
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    fontSize: "18px",
                    fontWeight: "bold",
                    color: "#4267AE",
                    marginBottom: "10px",
                  }}
                >
                  <span style={{ marginRight: "8px" }}>
                    <i
                      className={item.icon}
                      aria-hidden="true"
                      style={{ marginRight: "5px" }}
                    ></i>
                    {"  "}
                    {item.title}
                  </span>
                </div>
                <div style={{ fontSize: "13px", color: "#939393" }}>
                  {item.desc}
                </div>
              </div>
            </Link>
          ))}
        </div>

        <h3
          style={{
            fontWeight: "bold",
            color: "#323232",
            marginTop: "40px",
            marginBottom: "20px",
            fontFamily: "sans-serif",
          }}
        >
          Getting Started
        </h3>
        <div className="intro-video-grid">
          {gettingStartedVideos.map((video, idx) => (
            <IntroVideoCard key={idx} video={video} />
          ))}
        </div>

        {/* <h3
          style={{
            fontWeight: "bold",
            color: "#323232",
            marginBottom: "20px",
            fontFamily: "sans-serif",
          }}
        >
          DIY Videos
        </h3>
        <div className="video-grid">
          {videoDetails.map((video, idx) => (
            <LazyVideo key={idx} video={video} index={idx} />
          ))}
        </div> */}

        <div className="intro-app-links">
          <div className="intro-app-links-divider">
            <span>Download Mobile App</span>
          </div>
          <div className="intro-app-links-badges">
            <a
              href="https://apps.apple.com/in/app/homehub360-ai/id6745007392"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={appstore} alt="Download on the App Store" />
            </a>
            <a
              href="https://play.google.com/store/apps/details?id=com.siteone.homehub"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={googleplay} alt="Get it on Google Play" />
            </a>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    homeownerLots: state.LotStore.HomeownerLots
  };
};

export default withRouter(connect(mapStateToProps)(HomeownerIntro));


// WEBPACK FOOTER //
// ./src/portal_homeowner/intro.js